<template>
     <b-container class="d-flex p-0">
        <div v-if="IsEditor" 
            class="d-flex align-items-center my-auto pr-2 h5"> 
            <b-icon-gear 
                style="pointer-events: all; cursor: pointer;" />
                <!-- @click="changeParameter(fieldSet)" /> -->
        </div>
        <b-form-radio-group
            :options="Parameter.Options"
            value-field="Key"
            text-field="Value"
            v-model="Parameter.Selected"
            plain />
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import Parameter from '../Parameter';
    import RadioGroupField from '../Class/RadioGroupField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class RadioGroupItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public Parameter!: RadioGroupField;

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }

</script>

<style scoped>
</style>